import React, { SyntheticEvent, useContext } from "react";
import { Rule } from "types";
import {
  ListItemButton,
  ListItemSecondaryAction,
  IconButton,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  AddCircleOutlineOutlined,
  RemoveCircleOutlineOutlined,
} from "@mui/icons-material";
import { MobileTransferListItemProps } from "components/lists/MobileTransferList";
import { AppContext } from "context/appContext";
import { useNavigate } from "react-router";
import { ROUTES, routeWithParams } from "router";
import { useTranslation } from "react-i18next";

const RuleMobileTransferListItem: React.FC<
  MobileTransferListItemProps<Rule>
> = ({ item: rule, handleToggle, included, readonly }) => {
  const { t } = useTranslation();
  const isPhone = useMediaQuery(useTheme().breakpoints.down("sm"));
  const navigate = useNavigate();
  const { state } = useContext(AppContext);

  const canViewRule = state.entityPermissions.rule.read;

  const handleListButtonClick = (e: SyntheticEvent) => {
    e.stopPropagation();
    if (canViewRule) {
      navigate(routeWithParams(ROUTES.RULES_FORM, [state.tenant.id, rule.id]));
    }
  };

  const handleIconButtonClick = (e: SyntheticEvent) => {
    e.stopPropagation();
    handleToggle(rule);
  };

  return (
    <ListItemButton
      disableGutters
      dense={isPhone}
      divider
      onClick={handleListButtonClick}
      sx={{ px: 1 }}
    >
      <ListItemText
        primary={rule.name}
        primaryTypographyProps={{
          noWrap: true,
          variant: isPhone ? "h6" : "h5",
        }}
        secondary={canViewRule ? t("ruleset.mobileItemTap") : rule.description}
        secondaryTypographyProps={{ noWrap: true, variant: "subtitle1" }}
        sx={{ pl: { xs: 1, sm: 2 } }}
      />
      {!readonly && (
        <ListItemSecondaryAction>
          <IconButton
            onClick={handleIconButtonClick}
            sx={{ px: 2.25 }}
            size={"large"}
          >
            {included ? (
              <RemoveCircleOutlineOutlined color={"error"} fontSize="large" />
            ) : (
              <AddCircleOutlineOutlined color={"success"} fontSize="large" />
            )}
          </IconButton>
        </ListItemSecondaryAction>
      )}
    </ListItemButton>
  );
};

export default RuleMobileTransferListItem;
